import ResetPassword from './ResetPasswordController';

export default ResetPassword;
